import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'utils/yup';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { ValuationEstimateStorageRepository } from 'interfaceAdapter/repositories/ValuationEstimateStorage';
import { useLoading } from 'application/contexts/useLoading';

const schema = yup
    .object({
        email: yup.string().default('').required().email(),
        agreed: yup.boolean().default(false).oneOf([true], '利用規約に同意してください').required(),
        privacyAgreed: yup.boolean().default(false).oneOf([true], 'プライバシーポリシーに同意してください').required(),
        cookieAgreed: yup.boolean().default(false).oneOf([true], 'Cookie利用に同意してください').required(),
    })
    .required();

type SendEmailForm = yup.InferType<typeof schema>;

export const useSendRegistrationMail = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const valuationEstimateStorageRepository = diContainer.resolve(ValuationEstimateStorageRepository);
    const { loading, setLoading } = useLoading();
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm<SendEmailForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
            agreed: false,
            privacyAgreed: false,
            cookieAgreed: false,
        },
    });

    const sendMail = handleSubmit(async ({ email }) => {
        setLoading(true);
        try {
            // セッションストレージから企業価値情報を取得
            const valuationEstimateInfo = valuationEstimateStorageRepository.get();

            // 企業価値情報があれば一緒に送信
            await userRegisterRepository.sendCompanyRegistrationEmail(email, valuationEstimateInfo);

            // 送信後、セッションストレージから削除
            if (valuationEstimateInfo) {
                valuationEstimateStorageRepository.remove();
            }

            navigate('/send-registration-mail/complete/');
        } finally {
            setLoading(false);
        }
    });

    return {
        control,
        errors,
        loading,
        sendMail,
        getValues,
    };
};
